// extracted by mini-css-extract-plugin
export default {"Highlight":"app_Highlight__VweZd","App":"app_App__s6hGw","Footer":"app_Footer__4rr+q"};